import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-cmodal',
  templateUrl: './cmodal.component.html',
  styleUrls: ['./cmodal.component.css']
})
export class CmodalComponent implements OnInit, AfterViewInit {

  @Input() modalId: string = 'modal-' + Date.now();
  @Input() opened: boolean;
  @Input() width: string;
  //@Input() width = '600px';
  @Input() contentHeight: string;
  @Input() pxPer: string;
  @Input() title: string;
  @Input() hideClose: boolean;
  @Input() print: boolean;
  @Input() rawContent: boolean;
  @Input() isShowBackButton: boolean;
  @Input() isMarketingPopup: boolean;

  @Output() openedChange: EventEmitter<boolean> = new EventEmitter();
  @Output() back: EventEmitter<void> = new EventEmitter();
  constructor() { }

  ngOnInit() {
    this.setWidthAndHeight();
  }

  ngAfterViewInit() { }

  setWidthAndHeight() {
    /*
     Default with should be 600px, but in modal popup needs to have different type of width needed
     then this logic will be usefull for both kind of widths
    */
    if (this.contentHeight != 'auto') {
      this.contentHeight = this.contentHeight + 'px';
    }
    if (this.width !== 'auto') {
      if (this.width == undefined || this.width == null) {
        this.width = '600px';
      } else {
        if (this.pxPer == '%') {
          this.width = this.width + '%';
        } else {
          this.width = this.width + 'px';
        }
      }
    }
  }

  close() {
    this.opened = false;
    this.openedChange.emit(false);
  }

  open() {
    this.opened = true;
    this.openedChange.emit(true);
  }

  onBack() {
    this.back.emit();
  }

  get height() {
    return this.print ? document.body.scrollHeight + 'px' : 'auto';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/cmodal/cmodal.component.ts